import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { t_machine, t_equipment_lease_machine } from 'types';
import { getDataStoreFieldMachine, getDataStoreFieldEquipment, equipmentNewItem } from './thunk';

interface InitialState {
  itemId: string;
  machine: t_machine[];
  equipment: t_equipment_lease_machine;
  dataStoreMachineFields?: any[];
  datastoreEquipmentFields?: any[];
}

const initialState: InitialState = {
  itemId: '',
  machine: [],
  equipment: {},
};

const MachineEquipmentSlice = createSlice({
  name: 'machineequipment',
  initialState,
  reducers: {
    newMachine(state, action: PayloadAction<t_machine[]>) {
      return { ...state, machine: action.payload };
    },
    newEquipment(state, action: PayloadAction<t_equipment_lease_machine>) {
      return { ...state, equipment: action.payload };
    },
    resetState(state) {
      return { ...state, machine: [], equipment: {} };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(equipmentNewItem.fulfilled, (state, action) => ({ ...state, itemId: action.payload.item_id }));
    builder.addCase(getDataStoreFieldMachine.fulfilled, (state, action) => ({
      ...state,
      dataStoreMachineFields: Object.entries(action.payload.data.fields),
    }));
    builder.addCase(getDataStoreFieldEquipment.fulfilled, (state, action) => ({
      ...state,
      datastoreEquipmentFields: Object.entries(action.payload.data.fields),
    }));
  },
});

export const { newMachine, newEquipment, resetState } = MachineEquipmentSlice.actions;

export default MachineEquipmentSlice.reducer;
